module.exports = __webpack_public_path__ + "static/img/banner-bg.18094b0c.png";